import http from '~/shared/http';
import { jsonRequestHeaders } from '~/csrf';
import favorites from '~/favoritesStore';

export interface PodcastListItem {
  id: string;
  title: string;
  summary: string;
  images: {
    large: string;
    small: string;
    medium: string;
    mini: string;
    srcset: string;
  };
  genre: string | null;
  url: string;
}

const PENDING_LIKE_KEY = 'poddtoppen:pending-like';

export function getLegacyLikes() {
  return favorites
    .getAll()
    .map(({ id }) => `${id}`)
    .filter(Boolean);
}

function readSessionStorage(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeSessionStorage(key: string, value: string): void {
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // Ignore storage failures.
  }
}

function removeSessionStorage(key: string): void {
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // Ignore storage failures.
  }
}

export async function fetchLikedPodcasts(): Promise<PodcastListItem[]> {
  const { data } = await http.get('/me/podcast-likes', {
    headers: jsonRequestHeaders(),
  });

  return data.data;
}

export async function fetchPodcastLikeStatus(itunesId: string): Promise<boolean> {
  const { data } = await http.get(`/me/podcast-likes/${itunesId}`, {
    headers: jsonRequestHeaders(),
  });

  return Boolean(data?.data?.liked);
}

export async function likePodcast(itunesId: string): Promise<void> {
  await http.post(
    '/me/podcast-likes',
    { itunes_id: itunesId },
    { headers: jsonRequestHeaders() },
  );
}

export async function unlikePodcast(itunesId: string): Promise<void> {
  await http.delete(`/me/podcast-likes/${itunesId}`, {
    headers: jsonRequestHeaders(),
  });
}

export async function importLegacyLikes(): Promise<string[]> {
  const legacyLikes = getLegacyLikes();

  if (legacyLikes.length === 0) {
    return [];
  }

  await http.post(
    '/me/podcast-likes/import',
    { podcast_itunes_ids: legacyLikes },
    { headers: jsonRequestHeaders() },
  );

  return legacyLikes;
}

export function setPendingLike(itunesId: string): void {
  writeSessionStorage(PENDING_LIKE_KEY, itunesId);
}

export function getPendingLike(): string | null {
  return readSessionStorage(PENDING_LIKE_KEY);
}

export function clearPendingLike(): void {
  removeSessionStorage(PENDING_LIKE_KEY);
}
